/**
 * Returns value closest to input
 * @param target
 * @param input
 */
export const closest = (target: number[], input: number): number =>
    [...target].sort((a, b) => Math.abs(a - input) - Math.abs(b - input))[0];

/**
 * Creates array of page positions
 * @param pages
 * @param parentWidth
 */
export const pagesToPagePositions = (pages: number, parentWidth: number): number[] =>
    Array.from(Array(pages), (_, i) => i).map(page => parentWidth * page);
